import { fetchGet } from '~utilities/fetch';

export async function loanEmailsListRequest(loanUuid: string, page: number, perPage: number): Promise<Response> {
    return fetchGet(`/loans/${loanUuid}/emails`, {
        page,
        perPage,
    });
}

export async function loanEmailTextRequest(loanEmailUuid: string): Promise<Response> {
    return fetchGet(`/loan-emails/${loanEmailUuid}/text`);
}
